{
  "welcome": "Selamat datang di",
  "instructions": "Ketuk di bawah untuk memulai proses check-in Anda.",
  "startCheckIn": "Mulai check-in",
  "missingWarehouseTitle": "Gudang Tidak Ditemukan",
  "missingWarehouseMessage": "Tautan tidak valid, tautan harus berisi ID Gudang",
  "recaptchaAttribution": "Situs ini dilindungi oleh reCAPTCHA dan berlaku {privacyPolicy} serta {termsOfService} Google.",
  "recaptchaPrivacyPolicy": "Kebijakan Privasi",
  "recaptchaTermsOfService": "Persyaratan Layanan",
  "lookupTitle": "Masukkan Nomor Referensi atau Nomor Konfirmasi untuk menemukan janji temu Anda",
  "referenceNumberLabel": "Nomor referensi atau Nomor konfirmasi",
  "referenceNotFoundError": "Nomor referensi atau konfirmasi tidak cocok dengan janji temu yang valid.",
  "checkIn": "Check-in",
  "loadTypeLabel": "Jenis muatan",
  "directionLabel": "Arah",
  "operationLabel": "Operasi",
  "dockLabel": "Dok",
  "orDivider": "atau",
  "noReferenceTitle": "Saya tidak memiliki nomor konfirmasi",
  "noReferenceDescription": "Lanjutkan tanpa janji temu menggunakan proses check-in standar.",
  "checkInWithoutAppointment": "Check-in tanpa janji temu",
  "readyToCheckInTitle": "Siap untuk check-in?",
  "readyToCheckInDescription": "Ketuk di bawah untuk memulai. Anda akan memasukkan detail Anda di layar berikutnya.",
  "referenceRequiredHint": "Nomor referensi diperlukan untuk check-in di lokasi ini.",
  "haveAppointment": "Saya memiliki janji temu",
  "direction": {
    "inbound": "Masuk",
    "outbound": "Keluar",
    "inOut": "Masuk & Keluar",
    "load": "Muat",
    "unload": "Bongkar"
  },
  "operation": {
    "live": "Langsung (Live)",
    "drop": "Lepas (Drop)",
    "other": "Lainnya"
  }
}
